import { render } from "./MontagesArchList.vue?vue&type=template&id=e3924116&scoped=true"
import script from "./MontagesArchList.vue?vue&type=script&lang=js"
export * from "./MontagesArchList.vue?vue&type=script&lang=js"

import "./MontagesArchList.vue?vue&type=style&index=0&id=e3924116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3924116"]])

export default __exports__